import { render, staticRenderFns } from "./UrlBlockingAlertModal.vue?vue&type=template&id=3b8892a0&scoped=true&"
import script from "./UrlBlockingAlertModal.vue?vue&type=script&lang=js&"
export * from "./UrlBlockingAlertModal.vue?vue&type=script&lang=js&"
import style0 from "./UrlBlockingAlertModal.vue?vue&type=style&index=0&id=3b8892a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8892a0",
  null
  
)

export default component.exports